import React from 'react';
import RequiredIndicator from '../RequiredIndicator';

const Input = ({
  label,
  name,
  placeholder,
  type,
  value,
  setValue,
  step = 0.1,
  min = 0,
  register,
  errors,
  errorMessage,
  required = false,
  className = '',
  ...props
}) => {
  const handleChange = (e) => {
    e.preventDefault();
    setValue(e.target.value);
  };

  return (
    <div className={`input-container ${className}`}>
      <label htmlFor={name} className>
        {required  && label && <RequiredIndicator label={label} />}
        {!required && label}
        <input
          step={step}
          min={min}
          ref={register}
          key={name}
          value={value}
          type={type}
          name={name}
          aria-invalid={errors[name] ? 'true' : 'false'}
          id={name}
          placeholder={placeholder}
          onChange={(e) => handleChange(e)}
          {...props}
        />
        {errorMessage && <b style={{ fontWeight: 'normal', fontSize: 'small', color: 'crimson' }}>{errorMessage}</b>}
      </label>
    </div>
  );
};

export default Input;
